import { Recipe } from '@akin-home/recipes';
import { useUpdateUserQuick } from '@akin-home/users/react';
import { useCallback } from 'react';
import { sendBackgroundMessage } from '../../chat/functions';
import { intent_labels } from '../../chat/intent_labels';
import { getCurrentUser } from '../../users/functions';
import { toggleInList } from '../../utils/arrays';

export const useToggleRecipeFavourite = () => {
  const update = useUpdateUserQuick();

  return useCallback((recipe: Recipe) => {
    const user = getCurrentUser();
    if (!user) return;

    const { id, favourite_recipe_ids } = user;

    const new_favourite_recipe_ids = toggleInList(
      favourite_recipe_ids,
      recipe.id
    );

    update.mutateAsync({
      input: { id, favourite_recipe_ids: new_favourite_recipe_ids },
    });

    sendBackgroundMessage(intent_labels.favourite_recipe, {
      context: { recipe: { id: recipe.id, name: recipe.name } },
    });
  }, []);
};
